import { API_BASE_URL } from "@/config";
import { BaseService } from "@/services/base-service";
import { CsrfService } from "@/services/csrf/csrf-service";
import type {
  AddressValidationRequest,
  AddressValidationResponse,
} from "./address-validation.types";

const ADDRESS_VALIDATION_PATH = "/address/validation";

export class AddressValidationService extends BaseService {
  private readonly csrfService: CsrfService;

  public constructor(csrfService: CsrfService = new CsrfService()) {
    super(API_BASE_URL);
    this.csrfService = csrfService;
  }

  public async validateAddress(
    request: AddressValidationRequest
  ): Promise<AddressValidationResponse> {
    const csrfToken = await this.csrfService.getToken();
    const response = await this.fetch(ADDRESS_VALIDATION_PATH, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-csrf-token": csrfToken,
      },
      body: JSON.stringify(request),
    });
    if (!response.ok) {
      throw new Error(`Address validation API error: ${response.status}`);
    }
    return (await response.json()) as AddressValidationResponse;
  }
}
